import React from 'react';
import { motion } from 'framer-motion';
import { usePrefersReducedMotion } from '../../hooks/usePrefersReducedMotion';

export function AnimatedProgressBar({
  percentage,
  className,
  duration = 0.8,
}: {
  percentage: number;
  className?: string;
  duration?: number;
}) {
  const reduced = usePrefersReducedMotion();
  const width = `${Math.min(Math.max(percentage, 0), 100)}%`;

  if (reduced) {
    return <div className={className} style={{ width }} />;
  }

  return (
    <motion.div
      className={className}
      initial={{ width: 0 }}
      animate={{ width }}
      transition={{ duration, ease: [0.4, 0, 0.2, 1] }}
    />
  );
}
